export const SET_CURRENT = "SET_CURRENT";
export const GET_SCREENLINK = "GET_SCREENLINK";
export const GET_SCREENLINKS = "GET_SCREENLINKS";
export const SCREENLINK_ERROR = "SCREENLINK_ERROR";
export const DELETE_SCREENLINK = "DELETE_SCREENLINK";
